import { ReactElement } from 'react';
import {
  ATMOSPHERIC_SOURCE_LABEL,
  AtmosphericSourceEnum,
  DynamicPressureSelection,
} from '../types/Run';

interface SyntheticDpBadgeProps {
  dp: DynamicPressureSelection | null | undefined;
  className?: string;
}

const label = (value: number | undefined): string =>
  value === undefined ? 'unknown' : (ATMOSPHERIC_SOURCE_LABEL[value as AtmosphericSourceEnum] ?? String(value));

/**
 * Amber pill shown when a run's dynamic pressure was synthesized
 * (0.5·ρ·v² from speed — no wind sensor). The tooltip carries the
 * provenance of each air-density input from the solve stamp.
 */
export default function SyntheticDpBadge({ dp, className }: SyntheticDpBadgeProps): ReactElement | null {
  if (!dp?.synthetic) return null;
  const rho = dp.air_density;
  const title =
    'Dynamic pressure synthesized from speed and resolved air density — ρ inputs: '
    + `Temp: ${label(rho?.temperature)}, Baro: ${label(rho?.barometric_pressure)}, `
    + `RH: ${label(rho?.humidity)}`
    + (dp.backfilled_channels?.length ? ` (${dp.backfilled_channels.length} channels backfilled)` : '');
  return (
    <span
      title={title}
      className={`cr-inline-flex cr-items-center cr-gap-1 cr-rounded-full cr-bg-amber-100 cr-px-2 cr-py-0.5
        cr-text-xs cr-font-medium cr-text-amber-800 ${className ?? ''}`}
    >
      <span className="cr-h-1.5 cr-w-1.5 cr-rounded-full cr-bg-current" />
      Synthetic DP
    </span>
  );
}
